import { ComponentPropsWithoutRef, ElementType } from 'react';

import { cx } from 'styled-system/css';
import { type TextVariantProps, text } from 'styled-system/recipes';

type Props<T extends ElementType> = TextVariantProps & { as?: T } & Omit<ComponentPropsWithoutRef<T>, 'as'>;

// Chakra v2 `<Text>` equivalent: a <p> with the project typography recipe.
export const Text = <T extends ElementType = 'p'>({ as, variant, className, ...rest }: Props<T>) => {
  const Element: ElementType = as ?? 'p';
  return <Element className={cx(text({ variant }), className)} {...rest} />;
};
